import React from "react";

const POSITION_CLASSES = {
  right:
    "absolute left-full top-1/2 z-20 ml-3 -translate-y-1/2",
  top: "absolute bottom-full left-1/2 z-20 mb-3 -translate-x-1/2",
  left: "absolute right-full top-1/2 z-20 mr-3 -translate-y-1/2",
  bottom: "absolute left-1/2 top-full z-20 mt-3 -translate-x-1/2",
};

const ARROW_CLASSES = {
  right: "absolute left-[-3px] top-1/2 -z-10 h-2 w-2 -translate-y-1/2 rotate-45",
  top: "absolute bottom-[-3px] left-1/2 -z-10 h-2 w-2 -translate-x-1/2 rotate-45",
  left: "absolute right-[-3px] top-1/2 -z-10 h-2 w-2 -translate-y-1/2 rotate-45",
  bottom: "absolute left-1/2 top-[-3px] -z-10 h-2 w-2 -translate-x-1/2 rotate-45",
};

const ToolTip = ({
  children,
  tooltipsContent,
  position = "top",
  className = "",
  tooltipClassName = "",
  useButton = false,
}) => {
  const hasCustomBg = /\bbg-/.test(tooltipClassName);
  const surfaceBg = hasCustomBg
    ? tooltipClassName.split(/\s+/).find((c) => c.startsWith("bg-"))
    : "bg-foreground";

  return (
    <div className={`w-full ${className}`}>
      <div className="group relative inline-block">
        {useButton ? (
          <button
            type="button"
            className="inline-flex rounded bg-primary-dark px-[18px] py-2 text-base font-semibold text-white"
          >
            {children}
          </button>
        ) : (
          <>{children}</>
        )}
        <div
          className={`${POSITION_CLASSES[position] || POSITION_CLASSES.top} pointer-events-none whitespace-nowrap rounded border border-border bg-foreground px-2 py-1 text-xs font-normal text-background opacity-0 shadow-md transition-opacity group-hover:opacity-100 ${tooltipClassName}`}
        >
          <span
            className={`${ARROW_CLASSES[position] || ARROW_CLASSES.top} rounded-sm ${surfaceBg}`}
          />
          <div dangerouslySetInnerHTML={{ __html: tooltipsContent }} />
        </div>
      </div>
    </div>
  );
};

export default ToolTip;
